'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

var _messageList = _interopRequireDefault(require("./../message-list"));

var _authorisation = _interopRequireDefault(require("./../authorisation"));

var _dashboardProjectList = _interopRequireDefault(require("../dashboard-project-list"));

var _dashboardOpenMembershipFeeList = _interopRequireDefault(require("../dashboard-open-membership-fee-list"));

var _dashboardUncheckedFarmList = _interopRequireDefault(require("../dashboard-unchecked-farm-list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

_es6Promise.default.polyfill();

var DashboardProjectListVomhof = (0, _authorisation.default)(['projectresponsible'], ['vomhof'], false)(_dashboardProjectList.default);
var DashboardProjectListBrunch = (0, _authorisation.default)(['projectresponsible'], ['brunch'], false)(_dashboardProjectList.default);
var DashboardProjectListSchub = (0, _authorisation.default)(['projectresponsible'], ['schub'], false)(_dashboardProjectList.default);
var DashboardProjectListStallvisite = (0, _authorisation.default)(['projectresponsible'], ['stallvisite'], false)(_dashboardProjectList.default);
var DashboardProjectListLockpfosten = (0, _authorisation.default)(['projectresponsible'], ['lockpfosten'], false)(_dashboardProjectList.default);
var DashboardProjectListToh = (0, _authorisation.default)(['projectresponsible'], ['toh'], false)(_dashboardProjectList.default);
var DashboardProjectListLgw = (0, _authorisation.default)(['projectresponsible'], ['lgw'], false)(_dashboardProjectList.default);

var ProjectResponsibleDashboard = /*#__PURE__*/function (_React$Component) {
  _inherits(ProjectResponsibleDashboard, _React$Component);

  function ProjectResponsibleDashboard(props) {
    var _this;

    _classCallCheck(this, ProjectResponsibleDashboard);

    _this = _possibleConstructorReturn(this, (ProjectResponsibleDashboard.__proto__ || Object.getPrototypeOf(ProjectResponsibleDashboard)).call(this, props));
    _this.state = {
      listsConfig: {
        vomhof: {
          label: props.t('open list vomhof'),
          anchor: 'vomhof-list',
          visible: true,
          isProject: true
        },
        brunch: {
          label: props.t('open list brunch'),
          anchor: 'brunch-list',
          visible: true,
          isProject: true
        },
        schub: {
          label: props.t('open list schub'),
          anchor: 'schub-list',
          visible: true,
          isProject: true
        },
        stallvisite: {
          label: props.t('open list stallvisite'),
          anchor: 'stallvisite-list',
          visible: true,
          isProject: true
        },
        lockpfosten: {
          label: props.t('open list lockpfosten'),
          anchor: 'lockpfosten-list',
          visible: true,
          isProject: true
        },
        toh: {
          label: props.t('open list toh'),
          anchor: 'toh-list',
          visible: true,
          isProject: true
        },
        lgw: {
          label: props.t('open list lgw'),
          anchor: 'lgw-list',
          visible: true,
          isProject: true
        },
        message: {
          label: props.t('message list'),
          anchor: 'message-list',
          visible: true,
          isProject: false
        },
        openMembershipFee: {
          label: props.t('Offene Mitgliederbeiträge'),
          anchor: 'open-membership-fee-list',
          visible: true
        },
        uncheckedFarm: {
          label: props.t('Nicht geprüfte Hofdaten'),
          anchor: 'unchecked-farm-list',
          visible: true
        }
      }
    };
    _this.initSubMenu = _this.initSubMenu.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ProjectResponsibleDashboard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initSubMenu();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          t = _this$props.t,
          history = _this$props.history,
          i18n = _this$props.i18n;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: 'comp-project-responsible-dashboard'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'project-vomhof'
      }, /*#__PURE__*/_react.default.createElement(DashboardProjectListVomhof, {
        t: t,
        projectKey: 'vomhof',
        i18n: this.props.i18n,
        history: this.props.history,
        enableAssignToUser: false,
        loadProjectUrl: "/api/".concat(this.props.i18n.language, "/") + 'administration/project/open-publish-requests?projects=vomhof',
        label: this.state.listsConfig.vomhof.label,
        anchor: this.state.listsConfig.vomhof.anchor
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: 'project-bruch'
      }, /*#__PURE__*/_react.default.createElement(DashboardProjectListBrunch, {
        t: t,
        projectKey: 'brunch',
        i18n: this.props.i18n,
        history: this.props.history,
        enableAssignToUser: false,
        loadProjectUrl: "/api/".concat(this.props.i18n.language, "/") + 'administration/project/open-publish-requests?projects=brunch',
        label: this.state.listsConfig.brunch.label,
        anchor: this.state.listsConfig.brunch.anchor
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: 'project-schub'
      }, /*#__PURE__*/_react.default.createElement(DashboardProjectListSchub, {
        t: t,
        projectKey: 'schub',
        i18n: this.props.i18n,
        history: this.props.history,
        enableAssignToUser: false,
        loadProjectUrl: "/api/".concat(this.props.i18n.language, "/") + 'administration/project/open-publish-requests?projects=schub',
        label: this.state.listsConfig.schub.label,
        anchor: this.state.listsConfig.schub.anchor
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: 'project-stallvisite'
      }, /*#__PURE__*/_react.default.createElement(DashboardProjectListStallvisite, {
        t: t,
        projectKey: 'stallvisite',
        i18n: this.props.i18n,
        history: this.props.history,
        enableAssignToUser: false,
        loadProjectUrl: "/api/".concat(this.props.i18n.language, "/") + 'administration/project/open-publish-requests?projects=stallvisite',
        label: this.state.listsConfig.stallvisite.label,
        anchor: this.state.listsConfig.stallvisite.anchor
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: 'project-lockpfosten'
      }, /*#__PURE__*/_react.default.createElement(DashboardProjectListLockpfosten, {
        t: t,
        projectKey: 'lockpfosten',
        i18n: this.props.i18n,
        history: this.props.history,
        enableAssignToUser: false,
        loadProjectUrl: "/api/".concat(this.props.i18n.language, "/") + 'administration/project/open-publish-requests?projects=lockpfosten',
        label: this.state.listsConfig.lockpfosten.label,
        anchor: this.state.listsConfig.lockpfosten.anchor
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: 'project-toh'
      }, /*#__PURE__*/_react.default.createElement(DashboardProjectListToh, {
        t: t,
        projectKey: 'toh',
        i18n: this.props.i18n,
        history: this.props.history,
        enableAssignToUser: false,
        loadProjectUrl: "/api/".concat(this.props.i18n.language, "/") + 'administration/project/open-publish-requests?projects=toh',
        label: this.state.listsConfig.toh.label,
        anchor: this.state.listsConfig.toh.anchor
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: 'project-lgw'
      }, /*#__PURE__*/_react.default.createElement(DashboardProjectListLgw, {
        t: t,
        projectKey: 'lgw',
        i18n: this.props.i18n,
        history: this.props.history,
        enableAssignToUser: false,
        loadProjectUrl: "/api/".concat(this.props.i18n.language, "/") + 'administration/project/open-publish-requests?projects=lgw',
        label: this.state.listsConfig.lgw.label,
        anchor: this.state.listsConfig.lgw.anchor
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: 'message-list'
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: this.state.listsConfig.message.anchor
      }, this.state.listsConfig.message.label), /*#__PURE__*/_react.default.createElement(_messageList.default, {
        history: this.props.history
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: 'open-membership-fee-list'
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: this.state.listsConfig.openMembershipFee.anchor
      }, this.state.listsConfig.openMembershipFee.label), /*#__PURE__*/_react.default.createElement(_dashboardOpenMembershipFeeList.default, {
        t: t,
        history: history,
        i18n: i18n
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: 'unchecked-farm-list'
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: this.state.listsConfig.uncheckedFarm.anchor
      }, this.state.listsConfig.uncheckedFarm.label), /*#__PURE__*/_react.default.createElement(_dashboardUncheckedFarmList.default, {
        t: t,
        history: history,
        i18n: i18n
      })));
    }
  }, {
    key: "initSubMenu",
    value: function initSubMenu() {
      var _this2 = this;

      if (this.props.getSubMenuConfig) {
        var config = Object.keys(this.state.listsConfig).filter(function (key) {
          if (_this2.props.projects.indexOf(key) >= 0 || !_this2.state.listsConfig[key].isProject) {
            return _this2.state.listsConfig[key].visible;
          }

          return false;
        }).map(function (key) {
          return _this2.state.listsConfig[key];
        });
        this.props.getSubMenuConfig(config);
      }
    }
  }]);

  return ProjectResponsibleDashboard;
}(_react.default.Component);

ProjectResponsibleDashboard.propTypes = {
  t: _propTypes.default.func.isRequired,
  history: _propTypes.default.object,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  projects: _propTypes.default.arrayOf(_propTypes.default.string),
  getSubMenuConfig: _propTypes.default.func
};
var _default = ProjectResponsibleDashboard;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/dashboard/project-responsible-dashboard.js
// module id = 754
// module chunks = 0